import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateE: SceneTemplate = {
    name: "תבנית ה",
    aspectRatio: "16:9",
    branding: {
        background: "primary",
        foreground: {
            color: "secondary",
            rounded: true,
            size: {
                width: 22.7,
                height: 66.66,
            },
            location: {
                x: 73.38,
                y: 16.66,
            },
        },
    },
    avatar: {
        nested: true,
        size: {
            width: 100,
            height: 100,
        },
        location: {
            x: 0,
            y: 0,
        },
    },
    scene: {
        scale: 66.66,
        rounded: true,
        location: {
            x: 3.9,
            y: 16.66,
        },
    },
};
